import { Input, Button, Badge, Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui';
import { Search, X, Filter } from 'lucide-react';
import { useQueryParams } from '@/hooks';
import { useEffect, useState } from 'react';
import AccountingFiltersSidebar from './AccountingFiltersSidebar';

const HeaderPageSearch = () => {
    const { values: [search], setValues, urlSearchParams } = useQueryParams(['search', 'type', 'status']);
    const [searchValue, setSearchValue] = useState(search || '');

    // Sync with URL when it changes externally
    useEffect(() => {
        setSearchValue(search || '');
    }, [search]);

    const performSearch = () => {
        setValues({ search: searchValue || undefined, page: 1 });
    };

    const handleClear = () => {
        setSearchValue('');
        setValues({ search: undefined, page: 1 });
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            performSearch();
        }
    };

    // Check if any filters are applied
    const getActiveFiltersCount = () => {
        const typesCount = urlSearchParams.getAll('type').length;
        const statusCount = urlSearchParams.getAll('status').length;
        return typesCount + statusCount;
    };

    const hasActiveFilters = getActiveFiltersCount() > 0;

    return (
        <div className="flex w-full md:w-80 gap-2 items-center">
            {/* Mobile Filter Button */}
            <div className="md:hidden">
                <Dialog>
                    <DialogTrigger asChild>
                        <Button
                            variant={hasActiveFilters ? "default" : "outline"}
                            size="sm"
                            className="relative h-9 px-3"
                        >
                            <Filter size={16} />
                            {hasActiveFilters && (
                                <Badge
                                    variant="secondary"
                                    className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs rounded-full bg-primary text-primary-foreground border-2 border-background"
                                >
                                    {getActiveFiltersCount()}
                                </Badge>
                            )}
                        </Button>
                    </DialogTrigger>
                    <DialogContent className="max-w-md w-[calc(100%-2rem)] rounded-2xl">
                        <DialogHeader>
                            <DialogTitle>Filtres</DialogTitle>
                        </DialogHeader>
                        <div className="py-2">
                            <AccountingFiltersSidebar />
                        </div>
                    </DialogContent>
                </Dialog>
            </div>

            <div className="flex flex-1 group">
                <div className="relative flex-1">
                    <Input
                        placeholder="Rechercher par nom..."
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyDown={onKeyDown}
                        className="h-9 text-sm bg-background border-muted-foreground/20 focus-visible:ring-0 focus-visible:ring-offset-0 rounded-r-none transition-all hover:bg-muted/30 pr-8"
                    />
                    {searchValue && (
                        <button
                            onClick={handleClear}
                            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors p-1"
                            title="Effacer la recherche"
                        >
                            <X size={14} />
                        </button>
                    )}
                </div>
                <Button
                    onClick={performSearch}
                    size="sm"
                    className="h-9 px-3 rounded-l-none border-l-0 bg-black text-white hover:bg-black/80 transition-colors"
                >
                    <Search size={16} />
                </Button>
            </div>
        </div>
    );
};

export default HeaderPageSearch;
